import { parseRequestError } from '@/common/utilities.ts'
import axiosInstance from '@/libs/axios_config.ts'
import { z } from 'zod'

const UserResponseSchema = z.object({
  id: z.number(),
})

type UserResponse = z.infer<typeof UserResponseSchema>

export const GETUser = async (id: number): Promise<UserResponse> => {
  try {
    const response = await axiosInstance.get(`scholar/users/${id}`, {})
    return UserResponseSchema.parse(response.data)
  } catch (error) {
    throw new Error(parseRequestError(error).message)
  }
}

const WhoAmIResponseSchema = z.object({
  id: z.number(),
  external_id: z.string().nullable(),
  status: z.number(),
  first_name: z.string().nullable(),
  middle_name: z.string().nullable(),
  last_name: z.string().nullable(),
  email: z.string(),
  phone: z.string().nullable(),
  address: z.string().nullable(),
  profile_picture: z.string().nullable(),
  language_preference_id: z.number().nullable(),
  global_country_id: z
    .number()
    .min(1, { message: 'Country is required' })
    .nullable(),
  city: z.string().min(1, { message: 'City is required' }).nullable(),
  shipping_address: z.string().nullable(),
  global_state_id: z
    .number()
    .min(1, { message: 'State is required' })
    .nullable(),
  global_timezone_id: z
    .number()
    .min(1, { message: 'Timezone is required' })
    .nullable(),
  date_of_birth: z.string().nullable().optional(),
  contact_preference: z.number().nullable(),
  access_2fa: z.number().nullable(),
  user_has_accepted_text_notifications: z.number().nullable(),
  unread_messages: z.number().nullable(),
})

export type User = z.infer<typeof WhoAmIResponseSchema>

export const GETMe = async (): Promise<User> => {
  try {
    const response = await axiosInstance.get('/scholar/auth/me')
    return WhoAmIResponseSchema.parse(response.data)
  } catch (error) {
    throw parseRequestError(error)
  }
}
